import { render, staticRenderFns } from "./classifications.vue?vue&type=template&id=5d2aab82"
import script from "./classifications.vue?vue&type=script&lang=js"
export * from "./classifications.vue?vue&type=script&lang=js"
import style0 from "./classifications.vue?vue&type=style&index=0&id=5d2aab82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports